module.exports = __webpack_public_path__ + "static/media/icon-score-5-scale-5.1e21112e.svg";